// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-8Ai","clinicsSelect":"styles_clinicsSelect__2_N6k"};